import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import WithTheme from 'components-stateless/Theme/WithTheme';

const SpinnerWrapper = styled.div`
  display: flex;

  align-items: center;
  -webkit-align-items: center;

  justify-content: center;
  -webkit-justify-content: center;

  flex-grow: 1;
`;

const StyledCube = styled.div`
  background-color: ${(props) => props.color};
`;

const CubeSpinner = ({ themeConfig, className }) => {
  const color = themeConfig ? themeConfig.uiControlBackgroundColor : '';
  return (
    <SpinnerWrapper className={className}>
      <div className="sk-cube-grid">
        <StyledCube color={color} className="sk-cube sk-cube1"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube2"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube3"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube4"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube5"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube6"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube7"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube8"></StyledCube>
        <StyledCube color={color} className="sk-cube sk-cube9"></StyledCube>
      </div>
    </SpinnerWrapper>
  );
};

CubeSpinner.propTypes = {
  className: PropTypes.string,
  themeConfig: PropTypes.object.isRequired,
};

CubeSpinner.defaultProps = {
  className: '',
};

export default WithTheme(CubeSpinner);
